import { render, staticRenderFns } from "./GIS.vue?vue&type=template&id=57fa98e8&"
import script from "./GIS.vue?vue&type=script&lang=js&"
export * from "./GIS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports